import firebase from 'firebase';
export class FavouriteScreenItem {
  favouriteListId?: string;
  screenId?: string;
  screen?: firebase.firestore.DocumentReference;
  constructor(
    favouriteListId?: string,
    screenId?: string,
    screen?: firebase.firestore.DocumentReference
  ) {
    this.favouriteListId = favouriteListId || null;
    this.screenId = screenId || null;
    this.screen = screen || null;
  }
}
